import { UserOutlined } from '@ant-design/icons';
import { getUser, logout } from '@efsa/dlw-authenticator';
import type { MenuProps } from 'antd';
import { Avatar, Menu } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import labels from 'ui/labels.json';
import logo from '../../../../assets/images/EFSA_logo.svg';

const {
  navigation: { lbl_appTitle },
} = labels;

const Logo = styled.img`
  display: inline-block;
  height: 46px;
  margin: 0 60px 0 0;

  &:hover {
    cursor: pointer;
  }
`;

const StyledMenu = styled(Menu)`
  padding: 0 48px;
  height: 70px;
  line-height: 70px;
  font-size: 16px;
  background-color: white;
  position: relative;
  box-shadow: 0px 2px 8px #e5e5e5;
  z-index: 1;

  .ant-menu-submenu-horizontal .ant-menu-submenu-arrow {
    display: none;
  }

  /* MenuItem styles */
  .ant-menu-item {
    margin: 0 !important;
    border-bottom: none !important;
    transition: none !important;
    padding: 0 24px !important;

    &::after {
      border-bottom: none !important;
    }

    &.ant-menu-item-selected,
    &.ant-menu-item-active {
      border-bottom: none !important;
      color: white !important;
      background-color: ${(props) => props.theme.colors.brandBlue} !important;

      &.logo {
        background-color: transparent !important;
      }
    }
    &.logo {
      padding: 0 !important;
      font-weight: 500;
      &:hover {
        color: ${(props) => props.theme.colors.fontColor} !important;
      }
    }
    span {
      transition: none !important;
    }
  }

  /* SubMenu styles */
  .ant-menu-submenu {
    height: 70px;
    padding: 0 !important;

    .ant-menu-title-content {
      display: none;
    }

    &::after {
      border-bottom: none !important;
    }

    .ant-menu-submenu-title {
      transition: none !important;
      height: 70px;
    }

    &:hover .user-menu-item {
      color: white !important;
    }

    &.ant-menu-submenu-open,
    &.ant-menu-submenu-active,
    &.ant-menu-item-active,
    &.ant-menu-submenu-selected {
      transition: none !important;
      color: white !important;
      background-color: ${(props) => props.theme.colors.brandBlue} !important;
    }
  }
`;

const AppTitle = styled.span`
  color: ${(props) => props.theme.colors.fontColor} !important;
  font-size: 18px;
  margin-right: 20px;
`;

const TitleBlock = styled.div`
  display: flex;
  align-items: center;
`;

const UserMenuItem = styled.div`
  padding: 0 30px;
  transition: none !important;
  span {
    margin-right: 6px;
  }
`;

const Navigation = () => {
  const navigation = useHistory();
  const { pathname } = navigation.location;
  const [openItem, setOpenItem] = useState(pathname);
  // @ts-expect-error: From other library
  const { name } = getUser();
  const userName = name && name.length ? name : 'unknown';

  const handleClick = (e: any) => {
    if (e.keyPath[1] === 'role') {
      return;
    }
    setOpenItem(e.key);
    navigation.push(e.key);
  };

  useEffect(() => {
    setOpenItem(pathname);
  }, [pathname]);

  const menuItems: MenuProps['items'] = useMemo(
    () => [
      {
        key: '/overview',
        className: 'logo',
        label: (
          <TitleBlock>
            <Logo src={logo} />
            <AppTitle>{lbl_appTitle}</AppTitle>
          </TitleBlock>
        ),
      },
      {
        key: '/user-actions',
        style: { marginLeft: 'auto' },
        label: (
          <UserMenuItem className="user-menu-item">
            <Avatar shape="square" icon={<UserOutlined />} />
            <span>{userName}</span>
          </UserMenuItem>
        ),
        children: [
          {
            key: '/sign-out',
            label: 'Sign out',
            onClick: () => {
              logout();
            },
          },
        ],
      },
    ],
    [userName]
  );

  return (
    <StyledMenu
      onClick={(e) => {
        handleClick(e);
      }}
      selectedKeys={[openItem]}
      mode="horizontal"
      triggerSubMenuAction="click"
      className="navigation"
      items={menuItems}
    />
  );
};

export default Navigation;
